import { useMutation } from 'react-query';
import { stripeError } from 'Core/utils/stripe';

export default function useHandleNextAction() {
  return useMutation(async ({ stripe, clientSecret }) => {
    const { error, paymentIntent } = await stripe.handleNextAction({ clientSecret });
    if (error) {
      throw stripeError(error);
    }
    return { status: paymentIntent?.status };
  });
}
